import { useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import RecommendationsContainer from '../../containers/RecommendationsContainer';
import useWootricSurvey from '../../hooks/useWootricSurvey';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import AnnouncementsSection from '../../features/announcements/components/AnnouncementsSection';
import HomePageSection from './HomePageSection';
import AcademyAssistantHomeSearchPrompt from '../../features/search/components/AcademyAssistantHomeSearchPrompt';
import MostPopularCertificates from '../MostPopularCertificates/MostPopularCertificates';
import { PersonaRecommendations } from '../../features/persona/PersonaRecommendations';
import FeaturedSection from '../../features/internalContent/components/FeaturedSection';
import { usePersonalizedHomepageOrder } from '../../features/personalization/hooks/usePersonalizedHomepageOrder';
import { SectionCarousel } from '../SectionCarousel';
import { SkeletonBlock, SkeletonWrapper } from 'academy-common-lib/components/Skeletons/subcomponents/Skeleton';
import { PageSectionHeading } from '../SectionHeading';
import { Box } from 'foundations-components/transitional/components/Box';
import CardsSection from 'academy-common-lib/features/cardsSection/components/CardsSection';
import { InProgressSectionSimplified } from '../../features/userProgress/components/InProgressSectionSimplified';
import { NavMarker } from 'react-rhumb';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcademyAssistantHomePageContent = () => {
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  const {
    loading: contentOrderLoading,
    items: contentOrder
  } = usePersonalizedHomepageOrder();
  const dynamicContent = useMemo(() => {
    const dynamicComponentMapping = {
      'internal-content': /*#__PURE__*/_jsx(FeaturedSection, {
        renderCompact: isTablet
      }),
      announcements: null,
      // rendered below the carousel so async loading doesn't disrupt layout
      'in-progress': /*#__PURE__*/_jsx(InProgressSectionSimplified, {}),
      'persona-based-recommendations': /*#__PURE__*/_jsx(PersonaRecommendations, {}),
      'progress-based-recommendations': /*#__PURE__*/_jsx(View, {
        "data-test-id": "pre-catalog-cards-container",
        children: /*#__PURE__*/_jsx(RecommendationsContainer, {
          cardSize: "large"
        })
      }),
      'popular-certificates': /*#__PURE__*/_jsx(View, {
        overflow: "hidden",
        children: /*#__PURE__*/_jsx(MostPopularCertificates, {})
      })
    };
    return contentOrder.map(barType => dynamicComponentMapping[barType]);
  }, [contentOrder, isTablet]);
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "100%",
    maxInlineSize: "100%",
    minInlineSize: "0",
    paddingInline: "400",
    children: /*#__PURE__*/_jsxs(CardWrapper, {
      borderRadius: "400",
      borderWidth: "0",
      inlineSize: "100%",
      marginBlock: "500",
      maxInlineSize: "100%",
      padding: "500",
      children: [/*#__PURE__*/_jsx(AcademyAssistantHomeSearchPrompt, {}), !!dynamicContent.length && /*#__PURE__*/_jsx(NavMarker, {
        name: "HOMEPAGE_SIMPLIFIED_LOADED",
        children: /*#__PURE__*/_jsx(View, {
          marginBlockStart: "500",
          children: /*#__PURE__*/_jsx(SectionCarousel, {
            children: dynamicContent
          })
        })
      }), !contentOrderLoading && /*#__PURE__*/_jsx(AnnouncementsSection, {}), contentOrderLoading && !dynamicContent.length && /*#__PURE__*/_jsxs(HomePageSection, {
        marginBlockStart: isMobile ? '500' : '1000',
        paddingBlock: "0",
        children: [/*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          marginBlockEnd: isMobile ? '200' : '400',
          children: /*#__PURE__*/_jsx(Box, {
            grow: 2,
            children: /*#__PURE__*/_jsx(PageSectionHeading, {
              marginBlockEnd: "0",
              subtitle: /*#__PURE__*/_jsx(SkeletonWrapper, {
                height: 18,
                width: 300,
                children: /*#__PURE__*/_jsx(SkeletonBlock, {
                  height: 18,
                  width: 300
                })
              }),
              title: /*#__PURE__*/_jsx(SkeletonWrapper, {
                height: 25,
                width: 200,
                children: /*#__PURE__*/_jsx(SkeletonBlock, {
                  height: 25,
                  width: 200
                })
              })
            })
          })
        }), /*#__PURE__*/_jsx(CardsSection, {
          appearsIn: "simplified-homepage",
          cardsContainerProps: {
            paddingBlockEnd: '0'
          },
          direction: isTablet ? 'column' : 'row',
          isLoading: true,
          maxSkeletonListLength: isTablet ? 3 : 4,
          size: isTablet ? 'small' : 'large'
        }), /*#__PURE__*/_jsx(View, {
          inlineSize: "100%",
          marginBlock: "500",
          children: /*#__PURE__*/_jsx(SkeletonWrapper, {
            borderRadius: "100",
            children: /*#__PURE__*/_jsx(SkeletonBlock, {
              height: 20,
              justifySelf: "center",
              width: 50
            })
          })
        })]
      })]
    })
  });
};
const AcademyAssistantHomePageLayout = () => {
  useWootricSurvey('CES');
  useWootricSurvey('CSAT');
  return /*#__PURE__*/_jsx(AcademyAssistantHomePageContent, {});
};
export default AcademyAssistantHomePageLayout;